/**
 * CRO PDP JavaScript — Livera Shield V5 (DRAFT)
 * Template: product.shield-v5  (based on ideal-upsell-popup-subscription)
 * V5: selling plans come from window.livera_plan_* (Liquid) which now resolves
 *     to the FIRMHOUSE plans for ALL markets → every subscription Firmhouse-managed.
 * Product: livera-shield (Shield CRO variants)
 *
 * Subscription popup logica:
 *  - vi==0 (1+1 Gratis) en vi==1 (1.5+1.5 Gratis): toon subscription popup na ATC klik
 *  - Popup: accept → vi==0: selling_plan 692188610906 (60d), vi==1: 692174750042 (90d) → redirect /cart
 *  - Popup: decline → voeg toe zonder selling_plan → redirect /cart
 *  - Popup: close (X) → sluit popup, voeg NIET toe
 *  - vi==2 (2+2 Gratis) en vi==3 (3+3 Gratis): direct toevoegen, geen popup
 *  - Triggers op ZOWEL hoofd-ATC knop als sticky ATC balk
 */

document.addEventListener('DOMContentLoaded', function () {
(function () {
  'use strict';

  // ─── VARIANT DATA ────────────────────────────────────────────────
  // Prijs per dag en vergelijkingsprijzen per variant index
  const variantData = {
    0: { perDay: '0.67', days: 60,  compare: 79.98  },  // 1+1 Gratis
    1: { perDay: '0.61', days: 90,  compare: 109.98 },  // 1.5+1.5 Gratis
    2: { perDay: '0.58', days: 120, compare: 139.98 },  // 2+2 Gratis
    3: { perDay: '0.56', days: 180, compare: 209.98 },  // 3+3 Gratis
  };

  // Subscription selling plan IDs per variant index
  // Geladen vanuit window.livera_plan_* (geïnjecteerd door Liquid + browser-taal override)
  const SELLING_PLAN_BY_VI = {
    0: window.livera_plan_60d || 692188610906,  // 1+1 Gratis  → 60 dagen plan
    1: window.livera_plan_90d || 692174750042,  // 1.5+1.5 Gratis → 90 dagen plan
  };

  // Popup-eligible variant indices (0 = 1+1 Gratis, 1 = 1.5+1.5 Gratis)
  const POPUP_ELIGIBLE_VI = [0, 1];

  // Upsell popup variant index (2 = 2+2 Gratis → upgrade naar 3+3 Gratis)
  const UPSELL_VI = 2;
  const UPSELL_TARGET_VARIANT_ID = '54170571997530'; // 3+3 Gratis variant ID

  // ─── VARIANT SWITCHING ───────────────────────────────────────────
  window.croSelectVariant = function (radioInput) {
    const card = radioInput.closest('.cro-variant-card');
    const variantId = card.dataset.variantId;
    const price = card.dataset.price;
    const _rawPerDay = card.dataset.perDay;
  const perDay = _rawPerDay === 'auto' ? calcPerDay(card.dataset.price, card.dataset.days) : null;
  const formatPerDay = (v) => v !== null ? formatCents(v) : formatDecimal(_rawPerDay);
    const compare = card.dataset.compare;

    // Deselect all cards
    document.querySelectorAll('.cro-variant-card').forEach(c => {
      c.classList.remove('cro-variant-card--selected');
    });
    card.classList.add('cro-variant-card--selected');

    // Update hidden form input
    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    // Update price display
    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');

    if (priceEl) priceEl.textContent = formatCents(price);
    if (compareEl) compareEl.textContent = formatCents(compare);
    if (perDayEl) { if (perDayEl.childNodes[0]) { perDayEl.childNodes[0].textContent = formatPerDay(perDay); } else { perDayEl.textContent = formatPerDay(perDay); } }

    // Calculate savings
    if (savingsEl) {
      const priceNum = parseInt(price, 10) / 100;
      const compareNum = parseInt(compare, 10) / 100;
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = getCurrencySymbol() + savings;
    }

    // Update sticky bar: variant naam + per-dag prijs
    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    const variantTitle = card.dataset.variantTitle || '';
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) { if (stickyPerDay.childNodes[0]) { stickyPerDay.childNodes[0].textContent = formatPerDay(perDay); } else { stickyPerDay.textContent = formatPerDay(perDay); } }

    // Update ATC button availability
    const atcBtn = document.getElementById('cro-atc-btn');
    const available = card.dataset.available === 'true';
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.innerHTML = available
        ? CART_SVG + ' ' + getAtcText()
        : getOutOfStockText();
    }
  };

  // ─── STICKY ATC BAR ──────────────────────────────────────────────
  const stickyBar = document.getElementById('cro-sticky-bar');
  const atcBtn = document.getElementById('cro-atc-btn');

  if (stickyBar && atcBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('cro-sticky-bar--visible');
        } else {
          stickyBar.classList.remove('cro-sticky-bar--visible');
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(atcBtn);
  }

  // ─── IMAGE SWITCHER met overlay toggle ─────────────────────────
  window.croSwitchImage = function (thumbBtn) {
    const newSrc = thumbBtn.dataset.src;
    const showOverlay = thumbBtn.dataset.overlay === 'true';
    const mainImg = document.getElementById('cro-main-image');
    const overlay = document.getElementById('cro-img-overlay');
    if (mainImg) {
      mainImg.src = newSrc;
      mainImg.style.opacity = '0';
      setTimeout(() => { mainImg.style.opacity = '1'; }, 50);
    }
    // Toon overlay alleen op lifestyle afbeelding
    if (overlay) {
      overlay.style.display = showOverlay ? 'flex' : 'none';
    }
    document.querySelectorAll('.cro-thumb').forEach(t => t.classList.remove('cro-thumb--active'));
    thumbBtn.classList.add('cro-thumb--active');
  };

  // ─── SMOOTH TRANSITION FOR MAIN IMAGE ───────────────────────────
  const mainImg = document.getElementById('cro-main-image');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.2s ease';
  }

  // ─── VIEWER COUNT ANIMATIE (fluctueert realistisch) ──────────────
  const viewerEl = document.getElementById('cro-viewer-count');
  if (viewerEl) {
    let count = parseInt(viewerEl.textContent) || 23;
    setInterval(() => {
      const delta = Math.random() < 0.5 ? 1 : -1;
      count = Math.max(18, Math.min(31, count + delta));
      viewerEl.textContent = count;
    }, 7000);
  }

  // ─── STOCK COUNT ANIMATIE (daalt langzaam) ───────────────────────
  const stockEl = document.getElementById('cro-stock-count');
  if (stockEl) {
    let stock = parseInt(stockEl.textContent) || 14;
    const stockInterval = setInterval(() => {
      if (stock > 7) {
        stock -= 1;
        stockEl.textContent = stock;
      } else {
        clearInterval(stockInterval);
      }
    }, Math.floor(Math.random() * 120000) + 180000); // 3-5 min
  }

  // ─── FAQ SMOOTH OPEN ─────────────────────────────────────────────
  document.querySelectorAll('.cro-faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        document.querySelectorAll('.cro-faq-item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  // ─── MID-PAGE CTA VARIANT SELECT ─────────────────────────────────
  window.croMidCtaSelect = function (btn) {
    document.querySelectorAll('.cro-midcta-variant').forEach(b => b.classList.remove('cro-midcta-variant--selected'));
    btn.classList.add('cro-midcta-variant--selected');

    const variantId = btn.dataset.variantId;
    const price = btn.dataset.price;
    const _rawPerDay = btn.dataset.perDay;
  const perDay = _rawPerDay === 'auto' ? calcPerDay(btn.dataset.price, btn.dataset.days) : null;
  const formatPerDay = (v) => v !== null ? formatCents(v) : formatDecimal(_rawPerDay);
    const compare = btn.dataset.compare;
    const variantTitle = btn.dataset.variantTitle;

    // Sync naar hoofd buy box
    const mainCards = document.querySelectorAll('.cro-variant-card');
    mainCards.forEach(card => card.classList.remove('cro-variant-card--selected'));
    const matchingCard = document.querySelector(`.cro-variant-card[data-variant-id="${variantId}"]`);
    if (matchingCard) {
      matchingCard.classList.add('cro-variant-card--selected');
      const radio = matchingCard.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    }

    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');
    if (priceEl) priceEl.textContent = formatCents(price);
    if (compareEl) compareEl.textContent = formatCents(compare);
    if (perDayEl) { if (perDayEl.childNodes[0]) { perDayEl.childNodes[0].textContent = formatPerDay(perDay); } else { perDayEl.textContent = formatPerDay(perDay); } }
    if (savingsEl) {
      const priceNum = parseInt(price, 10) / 100;
      const compareNum = parseInt(compare, 10) / 100;
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = getCurrencySymbol() + savings;
    }

    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) { if (stickyPerDay.childNodes[0]) { stickyPerDay.childNodes[0].textContent = formatPerDay(perDay); } else { stickyPerDay.textContent = formatPerDay(perDay); } }

    const selTitle = document.getElementById('cro-midcta-selected-title');
    const selPrice = document.getElementById('cro-midcta-selected-price');
    const selPerDay = document.getElementById('cro-midcta-selected-perday');
    if (selTitle) selTitle.textContent = variantTitle;
    if (selPrice) selPrice.textContent = price;
    if (selPerDay) { if (selPerDay.childNodes[0]) { selPerDay.childNodes[0].textContent = formatPerDay(perDay); } else { selPerDay.textContent = formatPerDay(perDay); } }
  };

  // ─── VARIANT CARD CLICK (entire card clickable) ──────────────────
  document.querySelectorAll('.cro-variant-card').forEach(card => {
    card.addEventListener('click', function () {
      const radio = this.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        croSelectVariant(radio);
      }
    });
  });

  // ─── I18N HELPERS ─────────────────────────────────────────────────
  const CART_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  function getAtcText() { const el = document.getElementById('cro-atc-text'); return el ? el.textContent.trim() : 'Voeg toe aan winkelwagen'; }
  function getOutOfStockText() { const el = document.getElementById('cro-out-of-stock-text'); return el ? el.textContent.trim() : 'Uitverkocht'; }
  function getDaysUnit() { const el = document.getElementById('cro-days-unit'); return el ? el.textContent.trim() : 'dagen'; }
  function getAutoDeliveryPrefix() { const el = document.getElementById('cro-auto-delivery-prefix'); return el ? el.textContent.trim() : 'Automatisch elke'; }
  function getSavingsPrefix() { const el = document.getElementById('cro-savings-prefix'); return el ? el.textContent.trim() : '↓ Bespaar €'; }
  function getCurrencySymbol() { return document.getElementById('cro-currency-symbol')?.textContent?.trim() || '€'; }
  function getCartUrl() {
    const parts = window.location.pathname.split('/');
    const seg = parts[1];
    if (seg && /^[a-z]{2}(-[a-z]{2})?$/.test(seg)) return '/' + seg + '/cart';
    return '/cart';
  }
  function formatCents(cents) {
    const sym = getCurrencySymbol();
    const sample = document.getElementById('cro-money-sample')?.textContent?.trim() || '€1,50';
    const decSep = (sample.replace(/[^.,]/g, '').length >= 2 && sample.includes('.')) ? '.' : ',';
    const val = (parseInt(cents, 10) / 100).toFixed(2).replace('.', decSep);
    return sym + val;
  }
  function calcPerDay(priceAttr, daysAttr) {
    return Math.round(parseInt(priceAttr, 10) / parseInt(daysAttr, 10));
  }
  function formatDecimal(dec) {
    const sym = getCurrencySymbol();
    const sample = document.getElementById('cro-money-sample')?.textContent?.trim() || '€1,50';
    const decSep = (sample.replace(/[^.,]/g, '').length >= 2 && sample.includes('.')) ? '.' : ',';
    const val = parseFloat(String(dec).replace(',', '.')).toFixed(2).replace('.', decSep);
    return sym + val;
  }

  // ─── HELPERS ─────────────────────────────────────────────────────
  function getSelectedVi() {
    const selected = document.querySelector('.cro-variant-card--selected');
    if (!selected) return 1;
    const vi = selected.dataset.vi;
    // sub90 kaart heeft data-vi="sub90" — behandel als aparte state
    if (vi === 'sub90') return 'sub90';
    return parseInt(vi);
  }

  // ─── SUBSCRIPTION CARD (onderste kaart: Abonnement) ─────────────
  window.croSelectSubscription90 = function () {
    const card = document.getElementById('cro-subscription-90-card');
    if (!card) return;

    // Deselect alle andere kaarten
    document.querySelectorAll('.cro-variant-card').forEach(c => {
      c.classList.remove('cro-variant-card--selected');
    });
    card.classList.add('cro-variant-card--selected');

    // Zet variant ID op de sub-variant (1.5+1.5 Gratis)
    const variantId = card.dataset.variantId;
    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    // Update prijs display
    const price = card.dataset.price;
    const compare = card.dataset.compare;
    const _rawPerDay = card.dataset.perDay;
  const perDay = _rawPerDay === 'auto' ? calcPerDay(card.dataset.price, card.dataset.days) : null;
  const formatPerDay = (v) => v !== null ? formatCents(v) : formatDecimal(_rawPerDay);
    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');
    if (priceEl) priceEl.textContent = formatCents(price);
    if (compareEl) compareEl.textContent = formatCents(compare);
    if (perDayEl) { if (perDayEl.childNodes[0]) { perDayEl.childNodes[0].textContent = formatPerDay(perDay); } else { perDayEl.textContent = formatPerDay(perDay); } }
    if (savingsEl) {
      const priceNum = parseInt(price, 10) / 100;
      const compareNum = parseInt(compare, 10) / 100;
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = getCurrencySymbol() + savings;
    }

    // Update sticky bar
    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    if (stickyVariant) stickyVariant.textContent = card.dataset.variantTitle || '';
    if (stickyPerDay) { if (stickyPerDay.childNodes[0]) { stickyPerDay.childNodes[0].textContent = formatPerDay(perDay); } else { stickyPerDay.textContent = formatPerDay(perDay); } }
  };

  function addToCartAndRedirect(variantId, sellingPlanId) {
    const body = { id: parseInt(variantId), quantity: 1 };
    if (sellingPlanId) body.selling_plan = parseInt(sellingPlanId);
    console.log('[Livera ATC] payload:', JSON.stringify(body), '| locale_group:', window.livera_locale_group);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) {
          console.error('[Livera ATC] cart/add.js error', r.status, JSON.stringify(err));
          // Als selling_plan ongeldig is, probeer zonder plan toe te voegen
          if (sellingPlanId && (r.status === 422 || r.status === 400)) {
            console.warn('[Livera ATC] selling_plan mislukt, toevoegen zonder plan als fallback');
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
            }).then(function() { window.location.href = getCartUrl(); });
          }
          window.location.href = getCartUrl();
        });
      }
      return r.json().then(function() { window.location.href = getCartUrl(); });
    })
    .catch(function(e) { console.error('[Livera ATC] fetch error', e); window.location.href = getCartUrl(); });
  }

  // ─── SUBSCRIPTION POPUP ──────────────────────────────────────────
  let _pendingVariantId = null; // variant ID die de gebruiker wilde toevoegen

  function getSelectedVariantPrice() {
    const selected = document.querySelector('.cro-variant-card--selected');
    return selected ? selected.dataset.price : null;
  }

  function showSubscriptionPopup(variantId) {
    _pendingVariantId = variantId;

    // Vul prijs dynamisch in op basis van geselecteerde variant
    const price = getSelectedVariantPrice();
    const priceEl = document.getElementById('lv-sub-popup-price');
    const compareEl = document.getElementById('lv-sub-popup-compare');

    if (priceEl && price) {
      // Bereken 20% korting voor abonnementsprijs
      const priceNum = parseInt(price, 10) / 100;
      const discountedPrice = (priceNum * 0.8).toFixed(2).replace('.', ',');
      priceEl.textContent = getCurrencySymbol() + discountedPrice;
    }
    if (compareEl && price) {
      compareEl.textContent = price;
    }

    // Voeg savings pill toe (besparing in €)
    const priceRow = document.querySelector('.lv-sub-popup__price-row');
    if (priceRow && price) {
      const priceNum = parseInt(price, 10) / 100;
      const discountedNum = priceNum * 0.8;
      const saving = (priceNum - discountedNum).toFixed(2).replace('.', ',');
      let pill = priceRow.querySelector('.lv-sub-popup__savings-pill');
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'lv-sub-popup__savings-pill';
        priceRow.appendChild(pill);
      }
      pill.textContent = getSavingsPrefix() + saving;
    }

    // Update perk2 tekst met juiste leverfrequentie per variant
    const vi = getSelectedVi();
    const perk2Li = document.getElementById('lv-sub-popup-perk2');
    if (perk2Li) {
      const days = vi === 0 ? 60 : 90;
      const svgEl = perk2Li.querySelector('svg');
      perk2Li.textContent = '';
      if (svgEl) perk2Li.appendChild(svgEl);
      perk2Li.appendChild(document.createTextNode(' ' + getAutoDeliveryPrefix() + ' ' + days + ' ' + getDaysUnit() + ' geleverd'));
    }

    // Toon popup
    const overlay = document.getElementById('lv-sub-popup-overlay');
    if (overlay) {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      // Focus op primaire CTA voor toegankelijkheid
      const acceptBtn = document.getElementById('lv-sub-popup-accept');
      if (acceptBtn) acceptBtn.focus();
    }
  }

  function closeSubscriptionPopup() {
    const overlay = document.getElementById('lv-sub-popup-overlay');
    if (overlay) {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    _pendingVariantId = null;
  }

  function handleAtcClick(variantId) {
    if (!variantId) return;
    const currentVi = getSelectedVi();

    if (currentVi === 'sub90') {
      // Abonnement kaart: direct toevoegen MET selling plan (692174750042 = Shield 90 dagen)
      const card = document.getElementById('cro-subscription-90-card');
      const planId = card ? parseInt(card.dataset.sellingPlan) : 692174750042;
      addToCartAndRedirect(variantId, planId);
    } else if (POPUP_ELIGIBLE_VI.includes(currentVi)) {
      // vi==0 of vi==1: toon subscription popup
      showSubscriptionPopup(variantId);
    } else if (currentVi === UPSELL_VI) {
      // vi==2 (2+2 Gratis): toon upsell popup naar 3+3 Gratis
      showUpsellPopup(variantId);
    } else {
      // vi==3 (3+3 Gratis): direct toevoegen zonder popup
      addToCartAndRedirect(variantId);
    }
  }

  // ─── UPSELL POPUP (2+2 → 3+3) ────────────────────────────────────
  let _pendingUpsellVariantId = null;

  function showUpsellPopup(variantId) {
    _pendingUpsellVariantId = variantId;
    const overlay = document.getElementById('lv-upsell-popup-overlay');
    if (overlay) {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const acceptBtn = document.getElementById('lv-upsell-popup-accept');
      if (acceptBtn) acceptBtn.focus();
    }
  }

  function closeUpsellPopup() {
    const overlay = document.getElementById('lv-upsell-popup-overlay');
    if (overlay) {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    _pendingUpsellVariantId = null;
  }

  // ─── POPUP EVENT LISTENERS ───────────────────────────────────────

  // Accept: voeg toe MET selling_plan (subscription) — plan afhankelijk van geselecteerde variant
  const acceptBtn = document.getElementById('lv-sub-popup-accept');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      const vid = _pendingVariantId;
      const vi = getSelectedVi();
      const planId = SELLING_PLAN_BY_VI[vi] || null;
      closeSubscriptionPopup();
      if (vid) {
        addToCartAndRedirect(vid, planId);
      }
    });
  }

  // Decline: voeg toe ZONDER selling_plan (eenmalige aankoop)
  const declineBtn = document.getElementById('lv-sub-popup-decline');
  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      const vid = _pendingVariantId;
      closeSubscriptionPopup();
      if (vid) {
        addToCartAndRedirect(vid);
      }
    });
  }

  // Close (X): sluit popup, voeg NIET toe
  const closeBtn = document.getElementById('lv-sub-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeSubscriptionPopup);
  }

  // Klik buiten popup: sluit popup
  const popupOverlay = document.getElementById('lv-sub-popup-overlay');
  if (popupOverlay) {
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closeSubscriptionPopup();
    });
  }

  // Escape toets: sluit popup
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const subOverlay = document.getElementById('lv-sub-popup-overlay');
      if (subOverlay && !subOverlay.hasAttribute('hidden')) closeSubscriptionPopup();
      const upsellOverlay = document.getElementById('lv-upsell-popup-overlay');
      if (upsellOverlay && !upsellOverlay.hasAttribute('hidden')) closeUpsellPopup();
    }
  });

  // ─── UPSELL POPUP EVENT LISTENERS ───────────────────────────────

  // Accept: voeg 3+3 Gratis toe (upgrade)
  const upsellAcceptBtn = document.getElementById('lv-upsell-popup-accept');
  if (upsellAcceptBtn) {
    upsellAcceptBtn.addEventListener('click', function () {
      closeUpsellPopup();
      addToCartAndRedirect(UPSELL_TARGET_VARIANT_ID);
    });
  }

  // Decline: voeg originele 2+2 Gratis toe
  const upsellDeclineBtn = document.getElementById('lv-upsell-popup-decline');
  if (upsellDeclineBtn) {
    upsellDeclineBtn.addEventListener('click', function () {
      const vid = _pendingUpsellVariantId;
      closeUpsellPopup();
      if (vid) addToCartAndRedirect(vid);
    });
  }

  // Close (X): sluit popup, voeg NIET toe
  const upsellCloseBtn = document.getElementById('lv-upsell-popup-close');
  if (upsellCloseBtn) {
    upsellCloseBtn.addEventListener('click', closeUpsellPopup);
  }

  // Klik buiten popup: sluit
  const upsellOverlayEl = document.getElementById('lv-upsell-popup-overlay');
  if (upsellOverlayEl) {
    upsellOverlayEl.addEventListener('click', function (e) {
      if (e.target === upsellOverlayEl) closeUpsellPopup();
    });
  }

  // ─── HOOFD ATC KNOP INTERCEPTIE ─────────────────────────────────
  const atcBtnEl = document.getElementById('cro-atc-btn');
  if (atcBtnEl) {
    atcBtnEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = document.getElementById('cro-variant-id')?.value;
      handleAtcClick(variantId);
    });
  }

  // ─── STICKY ATC CLICK ────────────────────────────────────────────
  window.croStickyATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    handleAtcClick(variantId);
  };

  // ─── MID-PAGE CTA ATC ────────────────────────────────────────────
  window.croMidCtaATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    handleAtcClick(variantId);
  };

  // ─── PRODUCT FORM SUBMIT INTERCEPTIE ────────────────────────────
  // Onderschep form submit (fallback voor browsers die JS click events missen)
  const productForm = document.querySelector('.cro-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      const currentVi = getSelectedVi();
      if (POPUP_ELIGIBLE_VI.includes(currentVi)) {
        e.preventDefault();
        const variantId = document.getElementById('cro-variant-id')?.value;
        handleAtcClick(variantId);
      }
      // vi==3 (3+3 Gratis): normaal form submit
    });
  }

})();
});
